import React from 'react'
import {
  List, Datagrid, TextField, BooleanInput, Filter,
  SimpleShowLayout, TextInput, ArrayField, Show, TopToolbar, SimpleForm
} from 'react-admin'
import { withRouter } from 'react-router'
import MuiButton from '@material-ui/core/Button'
import Tooltip from '@material-ui/core/Tooltip'
import PublishIcon from '@material-ui/icons/Publish'
import { ExportDataButton, GoToUser, UploadFileButton } from './Buttons'
import { makeUrl, replaceUrlParams } from './DataProvider/utils'
import { env } from './env'
import { DateTimeField } from './Fields'
import Pagination from './Pagination'
import { partnerExporter } from './exporter'

const { attachPolicyUrl, attachQuoteUrl, facadeBaseUrl, getSession } = env


const SearchFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Session" source="session" alwaysOn />
    <BooleanInput label="Received Quote" source="quote" alwaysOn />
    <BooleanInput label="Purchased Policy" source="bind" alwaysOn />
    <BooleanInput label="Waiting External Flows" source="external" alwaysOn />
  </Filter>
)

const SessionToolbar = withRouter((props: any) => {
  const { data = {}, history } = props
  return (
    <TopToolbar>
      {(data?.uid === '_anon__' || data?.uid === '__anon__') ? (
        <p style={{ cursor: 'not-allowed' }}>Anonymous User</p>
      ) : (
        <GoToUser history={history} uid={data?.uid} />
      )}
    </TopToolbar>
  )
})

const TextOrUrlField = (answer: any) => {
  if (answer.record.key === 'ICON_access_url') {
    const url = answer.record.answer
    return (<a href={url}>{url}</a>)
  }
  return (<TextField source="answer" />)
}

const GilderNameField = ({ record = {} }: any) => (
  <span>{record?.name || record?.uid || ''}</span>
)

const SessionEmailField = ({ record = {} }: any) => (
  <span>{record?.email || ''}</span>
)

export const SessionEdit = (props: any) => {
  const { id } = props
  const uid = id.split('_')[0]

  const sessionToCSV = (resp: any) => {
    return resp['data'].map((r: any) => {
      if (r['key'] == '_sparse-index') {
        return
      }
      r['answer'] = r['answer_human'] || r['answer']
      r['question'] = (r['question'] || {})['message']
      r['ts'] = new Date(r['ts']).toLocaleString()
      return r
    }).filter((r: any) => !!r)
  }

  const policyUrl = replaceUrlParams(makeUrl(facadeBaseUrl, attachPolicyUrl), { username: uid })
  const quoteUrl = replaceUrlParams(makeUrl(facadeBaseUrl, attachQuoteUrl), { username: uid })
  const sessionUrl = replaceUrlParams(makeUrl(facadeBaseUrl, getSession), { session: id })

  return (
    <Show {...props} actions={<SessionToolbar />}>
      <SimpleShowLayout>
        <SimpleForm>
          {uid ? (
            <UploadFileButton label="Attach Quote" upload_url={quoteUrl} user_id={uid} />
          ) : (
            <Tooltip title="File uploads disabled for anonymous session users">
              <span><MuiButton size="small" disabled startIcon={<PublishIcon />}>Attach Quote</MuiButton></span>
            </Tooltip>
          )}
          {uid ? (
            <UploadFileButton label="Attach Policy" upload_url={policyUrl} user_id={uid} />
          ) : (
            <Tooltip title="File uploads disabled for anonymous session users">
              <span><MuiButton size="small" disabled startIcon={<PublishIcon />}>Attach Policy</MuiButton></span>
            </Tooltip>
          )}
        </SimpleForm>
        <ExportDataButton getDataFn={sessionToCSV} fields={['question', 'key', 'answer', 'ts']} name={`session.${id}`} resourceUrl={sessionUrl} />
        <TextField source="session" />
        <ArrayField source="answers">
          <Datagrid>
            <TextField source="question.message" label="Question" />
            <TextField source="key" />
            <TextOrUrlField source="answer" />
            <DateTimeField source="ts" label="Timestamp" />
          </Datagrid>
        </ArrayField>
      </SimpleShowLayout>
    </Show>
  )
}

export const SessionsList = (props: any) => {
  return (
    <List {...props} filters={<SearchFilter />} bulkActionButtons={false} exporter={partnerExporter} sort={{ field: 'ts', order: 'DESC' }}>
      <Datagrid rowClick="edit">
        <TextField source="session" />
        <DateTimeField source="ts" label="Timestamp" />
        {/* <CarrierField source="carrier" label="Carrier" /> */}
        <GilderNameField label="Gilder" />
        <SessionEmailField label="Email" />
      </Datagrid>
    </List>
  )
}
